import { settlementTexts } from 'consts/text';
import { LabelMapper, PriceDeductionType } from 'types';

export const priceDeductionTypeLabels: LabelMapper<PriceDeductionType> = {
    PERCENTAGE: settlementTexts.children.costAllocation.percent,
    SPECIFIC_AMOUNT: settlementTexts.children.costAllocation.exact,
};
